export function deeplyConvertNullToUndefined<T>(object: T): T {
	const result: Record<string, unknown> = {};

	if (Array.isArray(object)) {
		return object.map(deeplyConvertNullToUndefined) as T;
	}

	if (object !== null && object !== undefined && typeof object === "object") {
		for (const [key, value] of Object.entries(object)) {
			result[key] = deeplyConvertNullToUndefined(value as Record<string, unknown>);
		}

		return result as T;
	}

	return (object ?? undefined) as T;
}
